import { Box } from 'braid-design-system';
import React from 'react';

import { BlueDotIcon } from 'src/app/views/shared/Icons/BlueDotIcon';
import { BlueTickIcon } from 'src/app/views/shared/Icons/BlueTickIcon';
import { GrayCircleFilledIcon } from 'src/app/views/shared/Icons/GrayCircleFilledIcon';
import { GrayCircleIcon } from 'src/app/views/shared/Icons/GrayCircleIcon';
import { GrayTickIcon } from 'src/app/views/shared/Icons/GrayTickIcon';

import { ICON_STATE } from '../constants';

import * as styles from './index.css';

const getIcon = (state: string) => {
  switch (state) {
    case ICON_STATE.GRAY_CIRCLE:
      return <GrayCircleIcon />;
    case ICON_STATE.GRAY_CIRCLE_FILLED:
      return <GrayCircleFilledIcon />;
    case ICON_STATE.BLUE_DOT:
      return <BlueDotIcon />;
    case ICON_STATE.BLUE_TICK:
      return <BlueTickIcon />;
    case ICON_STATE.GRAY_TICK:
      return <GrayTickIcon />;
    default:
      throw new Error(`Icon getIcon - invalid state: ${state}`);
  }
};

interface IconProps {
  state: string;
}

export const Icon = ({ state }: IconProps) => (
  <Box className={styles.root}>{getIcon(state)}</Box>
);
